var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { filterable: "", placeholder: "物品" },
                  model: {
                    value: _vm.paramsData.item_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "item_id", $$v)
                    },
                    expression: "paramsData.item_id"
                  }
                },
                _vm._l(_vm.dailyWelFareitemList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticStyle: { display: "flex" }, attrs: { span: 4 } },
            [
              _c("uploadImagetow", {
                ref: "uploadImagetow",
                staticStyle: { "margin-right": "20px" },
                attrs: {
                  filesname: "file",
                  Url: "WelfarlotteryCodeConfig",
                  title: "批量上传",
                  paramsData: _vm.paramsData
                },
                on: {
                  change: function($event) {
                    return _vm.getList(1)
                  }
                }
              }),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.getList } },
                [_vm._v("刷新")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        { attrs: { data: _vm.tableData, border: "" } },
        [
          _c("el-table-column", { attrs: { prop: "index", label: "序号" } }),
          _c("el-table-column", { attrs: { prop: "code", label: "兑换码" } })
        ],
        1
      ),
      _c("el-pagination", {
        staticStyle: { "text-align": "center" },
        attrs: {
          layout: "total,sizes, prev, pager, next",
          "current-page": _vm.currentPage,
          total: _vm.tableCopyTableList.length,
          "page-size": _vm.pageSize
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }